import React, { useEffect } from "react";
import styled from "styled-components";
import ReactHighcharts from "react-highcharts";
import numeral from "numeral";

ReactHighcharts.Highcharts.setOptions({
  lang: {
    decimalPoint: ".",
    thousandsSep: ","
  }
});

const Wrapper = styled.div`
  position: relative;
`;

const Title = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #5F6368;
  flex-direction: column;
  top: 0;
  pointer-events: none;
`;

const Line = styled.div`
  margin: 2px;
`;

const DonutChart = props => {
  const { data, title, lineShown, height } = props;

  const config = {
    chart: {
      type: "pie",
      height
    },
    credits: {
      enabled: false
    },

    tooltip: {
      enabled: true,
      formatter() {
        return `<b>${this.key
        }</b>: <b>${numeral(this.y).format("$0,00")}</b>`;
      }
    },

    title: { text: null },

    plotOptions: {
      pie: {
        innerSize: "75%",
        borderWidth: 0,
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
          format: "{point.name}<br/> ${point.y:,.0f}"
        }
      }
    },

    series: [{
      data: data.map(d => [d.label, d.value]),
      colors: data.map(d => d.color)
    }]
  };

  return (
    <Wrapper>
      <ReactHighcharts config={config} />
      <Title>{title.map(line => <Line>{line}</Line>)}</Title>
    </Wrapper>
  );
};

export default DonutChart;
